import React, { ReactElement } from 'react';

import { postUrl } from '@/common/iframe-post';

import Notice from '../module_actions/notice';

export default function bottom(props: {
  children: ReactElement;
  i18n: DetailTypes.I18n;
  abtest: DetailTypes.Abtest;
}) {
  const { children, i18n, abtest } = props || {};
  return (
    <div className="quick-bottom-layout">
      <Notice />

      <div className="quick-bottom">
        {abtest.quick_view_detail_ab_test !== 'test' && children}
        <button className="detail-simple" onClick={() => postUrl()}>
          {i18n['pc_detail_quick_view_view_detail']}
        </button>
      </div>
    </div>
  );
}
